module.exports = __webpack_public_path__ + "img/ibf-isolation.a95628f0.png";